/**
 * Gateway V2 ABI.
 *
 * Generated from arandao-contracts `src/v2/Gateway.sol:Gateway` via
 *   forge inspect src/v2/Gateway.sol:Gateway abi --json
 *
 * Do NOT regenerate from `out/Gateway.sol/Gateway.json` — forge writes
 * artifacts to out/<basename>.sol/<Name>.json, so src/Gateway.sol and
 * src/v2/Gateway.sol collide there and that path can hand you V1.
 *
 * Shape changes from V1 that callers must know about:
 *   - User.bv gained `gross_summ` (BV before the referral cut). `summ` is now
 *     NET; DNM entitlement is computed from `gross_summ`.
 *   - User gained `referrer` and `placementOrderId`.
 *   - Order gained `gross_bv_value`.
 *   - payment/paymentFrom take PlacementInput{referrer, parent} instead of a
 *     bare parent address.
 *   - DNM withdrawals are capped against the OLD gateway's dnm_withdraw plus
 *     this one's — V2 does not migrate reward history, it reads V1 for it.
 */
export const GATEWAY_ABI_V2 = [
  {
    type: "function",
    name: "minimumPurchaseBv",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "constructor",
    inputs: [
      {
        name: "token1",
        type: "address",
        internalType: "address",
      },
      {
        name: "token2",
        type: "address",
        internalType: "address",
      },
      {
        name: "daoAddress",
        type: "address",
        internalType: "address",
      },
      {
        name: "oldGatewayAddress",
        type: "address",
        internalType: "address",
      },
      {
        name: "dnmAddress",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "fallback",
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "BVPlan",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "DNM_SELLER_CURRENT_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "DNM_SELLER_MAX_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "DNM_USER_CURRENT_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "DNM_USER_MAX_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "DNM_VOUCHER_CURRENT_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "DNM_VOUCHER_MAX_REWARD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "DnmTokenAddress",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "ListLevelUpDate",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "date",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "level",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_REFERRAL_PERCENT",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "OrderList",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "user_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "seller_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "bv_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "sv_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "seller_token",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "date",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "data",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "exists",
        type: "bool",
        internalType: "bool",
      },
      {
        name: "gross_bv_value",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "SellerAddress",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "SellerList",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "seller_addr",
        type: "address",
        internalType: "address",
      },
      {
        name: "bv_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "token_withdraw_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "dnm_withdraw",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "exists",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "Token1",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IERC20",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "Token2",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IERC20",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UserAddress",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UserLevelUpDateIndex",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UserList",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "bv",
        type: "tuple",
        internalType: "struct UsersStruct.BusinessValue",
        components: [
          {
            name: "left",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "right",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "all_left",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "all_right",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "dir",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "level",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "summ",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "dnm_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "gross_summ",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
      {
        name: "last_order",
        type: "tuple",
        internalType: "struct UsersStruct.LastOrder",
        components: [
          {
            name: "date",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "order_id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv_level",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
      {
        name: "depth",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "pending_withdraw",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "levelup_count",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "lastweek",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "step",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "pending_voucher",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "exists",
        type: "bool",
        internalType: "bool",
      },
      {
        name: "data",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "referrer",
        type: "address",
        internalType: "address",
      },
      {
        name: "placementOrderId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UsersPaths",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UsersPathsHash",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "advanceImportStage",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "beginImport",
    inputs: [
      {
        name: "header",
        type: "tuple",
        internalType: "struct MigrationStorage.ManifestHeader",
        components: [
          {
            name: "schemaVersion",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceChainId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceBlockNumber",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceBlockHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "sourceBlockTimestamp",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "identities",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestIdentities",
            components: [
              {
                name: "oldGateway",
                type: "address",
                internalType: "address",
              },
              {
                name: "oldCalculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "faucetCalculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "calculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "dnm",
                type: "address",
                internalType: "address",
              },
              {
                name: "uvm",
                type: "address",
                internalType: "address",
              },
              {
                name: "usdt",
                type: "address",
                internalType: "address",
              },
              {
                name: "gateway",
                type: "address",
                internalType: "address",
              },
              {
                name: "owner",
                type: "address",
                internalType: "address",
              },
              {
                name: "dao",
                type: "address",
                internalType: "address",
              },
              {
                name: "feeWallet",
                type: "address",
                internalType: "address",
              },
            ],
          },
          {
            name: "codeHashes",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestCodeHashes",
            components: [
              {
                name: "oldGateway",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "oldCalculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "faucetCalculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "calculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "dnm",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "uvm",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "usdt",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "gateway",
                type: "bytes32",
                internalType: "bytes32",
              },
            ],
          },
          {
            name: "counters",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestCounters",
            components: [
              {
                name: "nextUserId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextLevelHistoryIndex",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextSellerId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextOrderId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gatewayOldUserId",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "liabilities",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestLiabilities",
            components: [
              {
                name: "cutoffVoucherPaid",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pendingVoucherLiability",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "protectedVoucherBaseline",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "requiredActivationUvmFunding",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "referralPercent",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "reconciliationSummaryHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "exceptionListHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "compatibilityInventoryHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "tables",
            type: "tuple[6]",
            internalType: "struct MigrationStorage.TableSpec[6]",
            components: [
              {
                name: "expectedCount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "expectedCommitment",
                type: "bytes32",
                internalType: "bytes32",
              },
            ],
          },
        ],
      },
      {
        name: "expectedManifestHash",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "calculate",
    inputs: [
      {
        name: "ordersId",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "calculateWeek",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "calculator",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract Calculator",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "changeFeeWallet",
    inputs: [
      {
        name: "walletAddress",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "configureDnmFaucet",
    inputs: [
      {
        name: "faucet",
        type: "address",
        internalType: "address",
      },
      {
        name: "oldUserId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "dao",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "dnm",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IDnmToken",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "dnmFaucet",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "dnmMintNonce",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "feeWallet",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "finalizeImport",
    inputs: [
      {
        name: "header",
        type: "tuple",
        internalType: "struct MigrationStorage.ManifestHeader",
        components: [
          {
            name: "schemaVersion",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceChainId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceBlockNumber",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sourceBlockHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "sourceBlockTimestamp",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "identities",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestIdentities",
            components: [
              {
                name: "oldGateway",
                type: "address",
                internalType: "address",
              },
              {
                name: "oldCalculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "faucetCalculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "calculator",
                type: "address",
                internalType: "address",
              },
              {
                name: "dnm",
                type: "address",
                internalType: "address",
              },
              {
                name: "uvm",
                type: "address",
                internalType: "address",
              },
              {
                name: "usdt",
                type: "address",
                internalType: "address",
              },
              {
                name: "gateway",
                type: "address",
                internalType: "address",
              },
              {
                name: "owner",
                type: "address",
                internalType: "address",
              },
              {
                name: "dao",
                type: "address",
                internalType: "address",
              },
              {
                name: "feeWallet",
                type: "address",
                internalType: "address",
              },
            ],
          },
          {
            name: "codeHashes",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestCodeHashes",
            components: [
              {
                name: "oldGateway",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "oldCalculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "faucetCalculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "calculator",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "dnm",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "uvm",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "usdt",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "gateway",
                type: "bytes32",
                internalType: "bytes32",
              },
            ],
          },
          {
            name: "counters",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestCounters",
            components: [
              {
                name: "nextUserId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextLevelHistoryIndex",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextSellerId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "nextOrderId",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gatewayOldUserId",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "liabilities",
            type: "tuple",
            internalType: "struct MigrationStorage.ManifestLiabilities",
            components: [
              {
                name: "cutoffVoucherPaid",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pendingVoucherLiability",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "protectedVoucherBaseline",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "requiredActivationUvmFunding",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "referralPercent",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "reconciliationSummaryHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "exceptionListHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "compatibilityInventoryHash",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "tables",
            type: "tuple[6]",
            internalType: "struct MigrationStorage.TableSpec[6]",
            components: [
              {
                name: "expectedCount",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "expectedCommitment",
                type: "bytes32",
                internalType: "bytes32",
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "floor",
    inputs: [
      {
        name: "a",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "b",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "gatewayOldUserId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getActiveDnmMintRequest",
    inputs: [],
    outputs: [
      {
        name: "nonce",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "entitlementType",
        type: "uint8",
        internalType: "enum IGatewayMintRequest.DnmEntitlementType",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getAllowance",
    inputs: [
      {
        name: "allowanceOwner",
        type: "address",
        internalType: "address",
      },
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getBit",
    inputs: [
      {
        name: "value",
        type: "bytes1",
        internalType: "bytes1",
      },
      {
        name: "position",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getOrderList",
    inputs: [
      {
        name: "orderId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "order",
        type: "tuple",
        internalType: "struct OrdersStruct.Order",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "user_id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "date",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "gross_bv_value",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getOrderLists",
    inputs: [
      {
        name: "fromId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "toId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct OrdersStruct.Order[]",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "user_id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "date",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "gross_bv_value",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getSeller",
    inputs: [
      {
        name: "_seller_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "ignore_vaildation",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct Sellers.Seller",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_addr",
            type: "address",
            internalType: "address",
          },
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "token_withdraw_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "dnm_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getSellerList",
    inputs: [
      {
        name: "fromId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "toId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct Sellers.Seller[]",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_addr",
            type: "address",
            internalType: "address",
          },
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "token_withdraw_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "dnm_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getUser",
    inputs: [
      {
        name: "userId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "ignoreValidation",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
      {
        name: "",
        type: "tuple",
        internalType: "struct UsersStruct.User",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv",
            type: "tuple",
            internalType: "struct UsersStruct.BusinessValue",
            components: [
              {
                name: "left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dir",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "level",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "summ",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dnm_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gross_summ",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "last_order",
            type: "tuple",
            internalType: "struct UsersStruct.LastOrder",
            components: [
              {
                name: "date",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "order_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv_level",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "depth",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "levelup_count",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "lastweek",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "step",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_voucher",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "placementOrderId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getUser",
    inputs: [
      {
        name: "userAddress",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "user",
        type: "tuple",
        internalType: "struct UsersStruct.User",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv",
            type: "tuple",
            internalType: "struct UsersStruct.BusinessValue",
            components: [
              {
                name: "left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dir",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "level",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "summ",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dnm_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gross_summ",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "last_order",
            type: "tuple",
            internalType: "struct UsersStruct.LastOrder",
            components: [
              {
                name: "date",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "order_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv_level",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "depth",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "levelup_count",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "lastweek",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "step",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_voucher",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "placementOrderId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getUserList",
    inputs: [
      {
        name: "fromId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "toId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct UsersStruct.UserInfo[]",
        components: [
          {
            name: "user",
            type: "tuple",
            internalType: "struct UsersStruct.User",
            components: [
              {
                name: "id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv",
                type: "tuple",
                internalType: "struct UsersStruct.BusinessValue",
                components: [
                  {
                    name: "left",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "right",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "all_left",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "all_right",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "dir",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "level",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "summ",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "dnm_withdraw",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "gross_summ",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "last_order",
                type: "tuple",
                internalType: "struct UsersStruct.LastOrder",
                components: [
                  {
                    name: "date",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "order_id",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "bv_level",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "depth",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pending_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "levelup_count",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "lastweek",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "step",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pending_voucher",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "exists",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "data",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "referrer",
                type: "address",
                internalType: "address",
              },
              {
                name: "placementOrderId",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "user_address",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "importLevelHistory",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedLevel[]",
        components: [
          {
            name: "globalIndex",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "userId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "date",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "level",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "importManifestHash",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "importOrders",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedOrder[]",
        components: [
          {
            name: "order",
            type: "tuple",
            internalType: "struct OrdersStruct.Order",
            components: [
              {
                name: "id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "user_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "seller_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv_value",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "sv_value",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "seller_token",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "date",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "data",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "exists",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "gross_bv_value",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "importPathHashes",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedPathWord[]",
        components: [
          {
            name: "userId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "wordIndex",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "value",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "importPaths",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedPathWord[]",
        components: [
          {
            name: "userId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "wordIndex",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "value",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "importSellers",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedSeller[]",
        components: [
          {
            name: "sellerAddress",
            type: "address",
            internalType: "address",
          },
          {
            name: "seller",
            type: "tuple",
            internalType: "struct Sellers.Seller",
            components: [
              {
                name: "id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "seller_addr",
                type: "address",
                internalType: "address",
              },
              {
                name: "bv_value",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "token_withdraw_value",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dnm_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "exists",
                type: "bool",
                internalType: "bool",
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "importStage",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "enum MigrationStorage.ImportStage",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "importTableState",
    inputs: [
      {
        name: "table",
        type: "uint8",
        internalType: "enum MigrationStorage.ImportTable",
      },
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct MigrationStorage.TableState",
        components: [
          {
            name: "expectedCount",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "importedCount",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "expectedCommitment",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "rollingCommitment",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "importUsers",
    inputs: [
      {
        name: "rows",
        type: "tuple[]",
        internalType: "struct GatewayMigrationLib.ImportedUser[]",
        components: [
          {
            name: "userAddress",
            type: "address",
            internalType: "address",
          },
          {
            name: "user",
            type: "tuple",
            internalType: "struct UsersStruct.User",
            components: [
              {
                name: "id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv",
                type: "tuple",
                internalType: "struct UsersStruct.BusinessValue",
                components: [
                  {
                    name: "left",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "right",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "all_left",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "all_right",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "dir",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "level",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "summ",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "dnm_withdraw",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "gross_summ",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "last_order",
                type: "tuple",
                internalType: "struct UsersStruct.LastOrder",
                components: [
                  {
                    name: "date",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "order_id",
                    type: "uint256",
                    internalType: "uint256",
                  },
                  {
                    name: "bv_level",
                    type: "uint256",
                    internalType: "uint256",
                  },
                ],
              },
              {
                name: "depth",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pending_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "levelup_count",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "lastweek",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "step",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "pending_voucher",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "exists",
                type: "bool",
                internalType: "bool",
              },
              {
                name: "data",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "referrer",
                type: "address",
                internalType: "address",
              },
              {
                name: "placementOrderId",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "isChildOfParent",
    inputs: [
      {
        name: "parent",
        type: "tuple",
        internalType: "struct UsersStruct.User",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv",
            type: "tuple",
            internalType: "struct UsersStruct.BusinessValue",
            components: [
              {
                name: "left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dir",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "level",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "summ",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dnm_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gross_summ",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "last_order",
            type: "tuple",
            internalType: "struct UsersStruct.LastOrder",
            components: [
              {
                name: "date",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "order_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv_level",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "depth",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "levelup_count",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "lastweek",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "step",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_voucher",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "placementOrderId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
      {
        name: "child",
        type: "tuple",
        internalType: "struct UsersStruct.User",
        components: [
          {
            name: "id",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "bv",
            type: "tuple",
            internalType: "struct UsersStruct.BusinessValue",
            components: [
              {
                name: "left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_left",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "all_right",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dir",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "level",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "summ",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "dnm_withdraw",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "gross_summ",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "last_order",
            type: "tuple",
            internalType: "struct UsersStruct.LastOrder",
            components: [
              {
                name: "date",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "order_id",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "bv_level",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "depth",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_withdraw",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "levelup_count",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "lastweek",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "step",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "pending_voucher",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "exists",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "placementOrderId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
      {
        name: "",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isDev",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "level_up_data_index",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "oldGateway",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IOldGateway",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "order_id",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "payment",
    inputs: [
      {
        name: "paymentData",
        type: "tuple",
        internalType: "struct Payments.PaymentData",
        components: [
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_address",
            type: "address",
            internalType: "address",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
      {
        name: "placement",
        type: "tuple",
        internalType: "struct Gateway.PlacementInput",
        components: [
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "parent",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "payment",
    inputs: [
      {
        name: "paymentData",
        type: "tuple",
        internalType: "struct Payments.PaymentData",
        components: [
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_address",
            type: "address",
            internalType: "address",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
      {
        name: "placement",
        type: "tuple",
        internalType: "struct Gateway.PlacementIdInput",
        components: [
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "parentId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "paymentFrom",
    inputs: [
      {
        name: "paymentData",
        type: "tuple",
        internalType: "struct Payments.PaymentData",
        components: [
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_address",
            type: "address",
            internalType: "address",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
      {
        name: "payer",
        type: "address",
        internalType: "address",
      },
      {
        name: "buyer",
        type: "address",
        internalType: "address",
      },
      {
        name: "placement",
        type: "tuple",
        internalType: "struct Gateway.PlacementIdInput",
        components: [
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "parentId",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "paymentFrom",
    inputs: [
      {
        name: "paymentData",
        type: "tuple",
        internalType: "struct Payments.PaymentData",
        components: [
          {
            name: "bv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "sv_value",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_token",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "seller_address",
            type: "address",
            internalType: "address",
          },
          {
            name: "data",
            type: "bytes32",
            internalType: "bytes32",
          },
        ],
      },
      {
        name: "payer",
        type: "address",
        internalType: "address",
      },
      {
        name: "buyer",
        type: "address",
        internalType: "address",
      },
      {
        name: "placement",
        type: "tuple",
        internalType: "struct Gateway.PlacementInput",
        components: [
          {
            name: "referrer",
            type: "address",
            internalType: "address",
          },
          {
            name: "parent",
            type: "address",
            internalType: "address",
          },
        ],
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "personalDnmPaid",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "protectedVoucherBaseline",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "referralPercent",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "requiredActivationUvmFunding",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "revokeAllowance",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "sellerDnmPaid",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "sellerWithdrawDNM",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "seller_id",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "setAllowance",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setCalculator",
    inputs: [
      {
        name: "cal",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setReferralPercent",
    inputs: [
      {
        name: "newPercent",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "sourceBlockHash",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "sourceBlockNumber",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "switchToProduction",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "userWithdrawDNM",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "userWithdrawDNMVoucher",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "userWithdrawWeekUVM",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "user_id",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "voucherBackendUsed",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "voucherDnmPaid",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "withdrawWithDao",
    inputs: [
      {
        name: "withdrawAmount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "withdrawalAddress",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "AddedSaleVolume",
    inputs: [
      {
        name: "seller_addr",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "added_volume",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "current_bv",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Calculated",
    inputs: [
      {
        name: "user_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "order_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "CalculatedWeek",
    inputs: [
      {
        name: "user_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "week_number",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "CreatedSeller",
    inputs: [
      {
        name: "id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "seller_addr",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "CreatedUser",
    inputs: [
      {
        name: "user_address",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "user_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "DnmFaucetConfigured",
    inputs: [
      {
        name: "faucet",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "oldUserId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "DnmWithdrawn",
    inputs: [
      {
        name: "beneficiary",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "entitlementType",
        type: "uint8",
        indexed: true,
        internalType: "enum IGatewayMintRequest.DnmEntitlementType",
      },
      {
        name: "requestNonce",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "voucherBackendUsed",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "GatewayActivated",
    inputs: [
      {
        name: "manifestHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "sourceBlockNumber",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LevelUp",
    inputs: [
      {
        name: "user_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "date",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "level",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "NewOrderEvent",
    inputs: [
      {
        name: "id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "seller_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "user_id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReferralPaid",
    inputs: [
      {
        name: "buyer",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "referrer",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "orderId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "grossBVPoints",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "referralCutPoints",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReferralPayoutSkipped",
    inputs: [
      {
        name: "buyer",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "orderId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "grossBVPoints",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "referralCutPoints",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReferralPercentChanged",
    inputs: [
      {
        name: "oldPercent",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "newPercent",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReferrerLocked",
    inputs: [
      {
        name: "user",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "referrer",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "firstOrderId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "UserPlaced",
    inputs: [
      {
        name: "user",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "parent",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "referrer",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "placementOrderId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "level",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "DnmCategoryCapExceeded",
    inputs: [
      {
        name: "entitlementType",
        type: "uint8",
        internalType: "enum IGatewayMintRequest.DnmEntitlementType",
      },
    ],
  },
  {
    type: "error",
    name: "DnmEntitlementExceeded",
    inputs: [
      {
        name: "requested",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "claimable",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "DnmFaucetAlreadyConfigured",
    inputs: [],
  },
  {
    type: "error",
    name: "DnmGlobalSupplyExceeded",
    inputs: [],
  },
  {
    type: "error",
    name: "DnmRequestAlreadyActive",
    inputs: [
      {
        name: "nonce",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "DnmVoucherBackendCapacityExceeded",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidAmount",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidCalculatorLevel",
    inputs: [
      {
        name: "userId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "level",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidDnmFaucet",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidDnmRequest",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidFromID",
    inputs: [
      {
        name: "fromId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidGatewayOldUser",
    inputs: [
      {
        name: "expectedId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "actualId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidGenealogySide",
    inputs: [
      {
        name: "targetUserId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "buyerUserId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "orderId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "side",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidPayment",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidPlacementState",
    inputs: [
      {
        name: "user",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidRangeID",
    inputs: [
      {
        name: "fromId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "toId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidToID",
    inputs: [
      {
        name: "toId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "LockedReferrerNotInGenealogy",
    inputs: [
      {
        name: "buyer",
        type: "address",
        internalType: "address",
      },
      {
        name: "referrer",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "NoActiveDnmRequest",
    inputs: [],
  },
  {
    type: "error",
    name: "OldGatewayUserMutation",
    inputs: [],
  },
  {
    type: "error",
    name: "OnlyDao",
    inputs: [],
  },
  {
    type: "error",
    name: "OrderBeforePlacement",
    inputs: [
      {
        name: "orderId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "buyerId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "placementOrderId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "OrderBuyerNotInGenealogy",
    inputs: [
      {
        name: "orderId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "buyerId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "OrderSequenceGap",
    inputs: [
      {
        name: "expectedOrderId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ParentCapacityReached",
    inputs: [
      {
        name: "parent",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ParentIdNotFound",
    inputs: [
      {
        name: "parentId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ParentNotPlaced",
    inputs: [
      {
        name: "parent",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "PaymentError",
    inputs: [],
  },
  {
    type: "error",
    name: "ProductionNotActive",
    inputs: [],
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: [],
  },
  {
    type: "error",
    name: "ReferralPercentTooHigh",
    inputs: [
      {
        name: "requested",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "maximum",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ReferrerNotPlaced",
    inputs: [
      {
        name: "referrer",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "SelfParent",
    inputs: [
      {
        name: "user",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "SelfReferral",
    inputs: [
      {
        name: "user",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "SellerNotFound",
    inputs: [
      {
        name: "seller_id",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "TransferError",
    inputs: [],
  },
  {
    type: "error",
    name: "UnauthorizedDnmRequestReader",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "UnexpectedDnmBalanceDelta",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "actual",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "UnexpectedVoucherCounterDelta",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "actual",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "UserNotFound",
    inputs: [],
  },
  {
    type: "error",
    name: "ZeroDnmWithdrawal",
    inputs: [],
  },
] as const;
